import "./App.css";
import Navbar from "./layouts/Navbar";
import Footer from "./layouts/Footer";
import AppRoot from "./AppRoot";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

function App() {
  const { i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.dir = direction; // Set `dir` attribute
    document.body.style.textAlign = direction === "rtl" ? "right" : "left"; // Optional: Adjust text alignment
  }, [direction]);

  return (
    <div className="App">
      <Navbar />
      <AppRoot />
      <Footer />
    </div>
  );
}

export default App;
